import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const OrderCancel = () => {
  const navigate = useNavigate();

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDCANCELORDER);
  };

  const handleOrderCancel = () => {
    navigate(ROUTES_NAVIGATION.VIEWORDERCANCEL)
  }

  return (
    <ListPage
    isUploadButtonRequired={false}
      headerTopText="Sales / Order Cancel"
      headerTitle="Order Cancel"
      addButtonTitle="Add Cancel Order"
      // uploadButtonTitle="Upload Customer"
      listTitle="All Customers"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleOnAddCustomerButton}
      handleOnUploadButton={() => {}}
      handleViewButton={handleOrderCancel}
    />
  );
};

export default OrderCancel;
